module.exports = __webpack_public_path__ + "static/media/DSC_0009.4932ad96.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/events/DSC_0009.jpg
// module id = 584
// module chunks = 0